import { commonLang } from '@umu/ukit-lang';
/**
 * @description
 */

import './userNameRole.scss';

import React, { Component } from 'react';

import { ROLE } from '@umu/umu-types';

export interface IProps {
    role: ROLE;
    roleName?: string;
}

export default class UserNameRole extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        if (!this.props.role) {
            return null;
        }
        return <span className="user-name-role">{this.props.roleName || commonLang('讲师')}</span>;
    }
}
